export enum DefectReportStatus {
  ReportPending = 'REPORT_PENDING',
  ReportSubmitted = 'REPORT_SUBMITTED',
  RepairInProgress = 'REPAIR_IN_PROGRESS',
  RepairDone = 'REPAIR_DONE',
}

export enum DefectReportStatusSearchable {
  Defect = 'DEFECT',
  Repair = 'REPAIR',
  Terminated = 'TERMINATED',
}
